import {NgModule} from "@angular/core";
import {RouterModule, Routes} from "@angular/router";
import {StoreComponent} from "./store.component";

const routes: Routes = [
    { path: 'store', component: StoreComponent}
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class StoreRoutingModule{}